import React from "react";
import { v4 as uuidv4 } from "uuid";
import { Formik, Form } from "formik";
import LdsTextField from "../components/LdsTextField";
import LdsValidationError from "../components/LdsValidationError";
import LdsButton from "../components/LdsButton";
import LdsDivider from "../components/LdsDivider";
import { BootstrapAlert } from "../components/BootstrapAlert";
import { ReactLoaderSpinner } from "../components/ReactLoaderSpinner";

// service
import {
  useLoginMutation,
  useGetCompanyNumberQuery,
} from "../store/services/authServerApi";

// import sign up validation schema
import { LoginSchema } from "../validationSchema/LoginSchema";
import { forceNavigate } from "../store/utils/helper";

const Login = () => {
  const { isLoading: isCompanyNumberFetched, data: { data = {} } = {} } =
    useGetCompanyNumberQuery(null, {
      skip: ~~sessionStorage.getItem("companyNo"), // skip if sessionStorage has companyNumber
    });
  if (~~data?.companyNumber) {
    sessionStorage.setItem("companyNo", ~~data?.companyNumber);
    sessionStorage.setItem("company", JSON.stringify(data));
  }

  const [
    login,
    {
      isLoading,
      error: { data: { message: errorMessage } = {} } = {},
      data: { responseBody: token } = {},
    },
  ] = useLoginMutation();

  if (token) {
    sessionStorage.setItem("token", token);
    forceNavigate("/");
  }

  const handleSubmit = (values) => {
    login(values);
  };

  return (
    <>
      {isCompanyNumberFetched && <ReactLoaderSpinner />}
      <main className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-6">
              <h1 className="blue text-uppercase b text-center">
                Please log in
              </h1>
              <p className="text-center mt-3">
                Amyvid Reader Training is primarily designed to enhance your
                proficiency in interpreting Amyvid scans.
              </p>
              <BootstrapAlert variant="danger" message={errorMessage} />
            </div>
          </div>
          <div className="row justify-content-center mt-3">
            <div className="col-sm-12 col-md-4">
              <Formik
                initialValues={{
                  username: "",
                  password: "",
                }}
                validationSchema={LoginSchema}
                onSubmit={handleSubmit}
              >
                {({ handleChange, values, errors, touched }) => (
                  <Form>
                    <div className="row">
                      <div className="col">
                        <LdsTextField
                          maxLength={100}
                          onChange={handleChange}
                          label="Email Address"
                          labelRequired
                          name="username"
                          id="username"
                          type="email"
                          error={errors.username && touched.username}
                        />
                        {errors.username && touched.username && (
                          <LdsValidationError id="errusername">
                            {errors.username}
                          </LdsValidationError>
                        )}
                        &nbsp;
                        <br />
                        <LdsTextField
                          maxLength={100}
                          onChange={handleChange}
                          label="Password"
                          labelRequired
                          name="password"
                          id="password"
                          type="password"
                          error={errors.password && touched.password}
                        />
                        {errors.password && touched.password && (
                          <LdsValidationError id="errpassword">
                            {errors.password}
                          </LdsValidationError>
                        )}
                        &nbsp;
                        <br />
                        <a href="/forgot" className="orange b">
                          Forgot Password?
                        </a>
                        <div className="col-sm-4 col-md-12">
                          <LdsButton
                            disabled={isLoading}
                            type="submit"
                            classes="blue-button mt-3"
                          >
                            Sign In
                          </LdsButton>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>

              <LdsDivider type="secondary" className="mt-5 mb-5" />
              <div className="row">
                <div className="col-sm-12 col-md-12">
                  <p>Don’t have an account?</p>
                </div>
                <div className="col-sm-12 col-md-12 text-right mb-5">
                  <a
                    href={`/register/${uuidv4()}`}
                    className="b white-button blue"
                  >
                    Register now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Login;
